/* eslint-disable no-trailing-spaces */
require('styles/Widget.scss');

import config from 'config';
import React, { Component } from 'react';
import { connect } from 'react-redux'
import StatusContainer from 'components/StatusContainer';
import FeedbackForm from 'components/FeedbackForm';
import MessageList from 'components/MessageList';
import ChatButton from 'components/ChatButton';
import Input from 'components/Input';
import { log, get, set } from 'utils';
import { debounce } from 'lodash';
import zChat from 'vendor/web-sdk';
import LoadingScreen from './LoadingScreen';
import {IMG_URL} from '../img/hosted_images'
import { setTimeout } from 'core-js';


const { ENV, ACCOUNT_KEY, THEME , BOT_DEP_ID} = config;

if (ENV === 'dev') {
  window.zChat = zChat;
}

class App extends Component {
  constructor() {
    super();
    this.state = {
      isNewChat : 0,
      theme: THEME,
      typing: false,
      visible: false,
      feedbackVisible: false,
      feedbackRating: 'good',
      feedback : false,
      reconnecting :false,
      chatBotState :false,

    };
    this.timer = null;
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.getVisibilityClass = this.getVisibilityClass.bind(this);
    this.minimizeOnClick = this.minimizeOnClick.bind(this);
    this.endChatButtonClick = this.endChatButtonClick.bind(this);
    this.chatButtonOnClick = this.chatButtonOnClick.bind(this);
    this.mapToEntities = this.mapToEntities.bind(this);
    this.isOffline = this.isOffline.bind(this);
    this.stopTyping = debounce(this.stopTyping.bind(this), 1000);
    this.setVisible = this.setVisible.bind(this);
    this.setTheme = this.setTheme.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.updateFeedbackRating = this.updateFeedbackRating.bind(this);
    this.submitFeedback = this.submitFeedback.bind(this);
    this.endChat = this.endChat.bind(this);
    this.isNewChatIncrement =  this.isNewChatIncrement.bind(this);
    this.onChangeFeedback = this.onChangeFeedback.bind(this);
  }

  componentDidMount() {
    zChat.init({
      account_key: ACCOUNT_KEY
    });

    const events = [
      'account_status',
      'connection_update',
      'department_update',
      'visitor_update',
      'agent_update',
      'chat',
      'error'
    ];

    events.forEach((evt) => {
      zChat.on(evt, (data) => {
        this.props.dispatch({
          type: evt,
          detail: data
        });
      });
    });
 
    // Expose onThemeChange to allow dynamic change of theme
    if (ENV === 'dev') {
      window.onThemeChange = this.onThemeChange.bind(this);
    }

    this.setState({
      visible: get('visible') || this.state.visible,
      theme: get('theme') || this.state.theme
    });
  }

componentDidUpdate(){

  // if(this.state.reconnecting){
  //   let connection_status = zChat.getConnectionStatus();
  //   console.log(connection_status);
  // }

      if(!this.props.data.chats.toArray().length && this.props.data.connection === 'connected' && this.state.visible && this.state.isNewChat < 1) {
    // console.log('++++++++++++ RELOAD NO CHAT +++++++++++++++++++');
    this.setState({
      isNewChat : this.state.isNewChat + 1
    })
    let visitorInfo = {
      display_name : ''
  };
    zChat.setVisitorInfo(visitorInfo,(err)=>{ 
      if(err) {log(err)}
      // console.log('--------VISITOR ID CHANGED-------------');
      zChat.setVisitorDefaultDepartment(BOT_DEP_ID, function(err) { 
          if(err) {log(err)}
          zChat.sendChatMsg('default_welcome', (err) => {
            if (err) {
              log('Error occured >>>', err);
            }
          });
      });
     });
    }
  // if(this.props.data.connection === 'closed' && !this.state.reconnecting){
  //   log('++++++++++++ CLOSED CONNECTION +++++++++++++++++++');

  //   this.setState({
  //     reconnecting : true
  //   })
  //       let visitorInfo = {
  //         display_name : ''
  //     };
  //     console.log('-----updating connection-------');
  //     zChat.reconnect();
  //     console.log('----- after updating connection-------');

  //     // let connection_status = zChat.getConnectionStatus();
  //     // console.log(connection_status);

  //     // this.props.dispatch({
  //     //   type: 'ON_EXIT',
  //     //   detail: {}
  //     // });

  //     // connection_status = zChat.getConnectionStatus();
  //     // console.log(connection_status)

  //     console.log('------ setting before visitor id -----');
  //       zChat.setVisitorInfo(visitorInfo,(err)=>{ 
  //         if(err) {console.log(err)}
  //         console.log('--------VISITOR ID CHANGED-------------');

  //        });
  //        console.log('------ setting after visitor id -----');
  //        console.log('------ sending default welocome -----');
  //        zChat.sendChatMsg('default_welcome', (err) => {
  //         if (err) {
  //           console.log('Error occured >>>', err);
  //         }
  //         console.log('inside sending default_message')
  //       });
  //       console.log('after sending default_message')

  //    let connection_status = zChat.getConnectionStatus();
  //     console.log(connection_status)

  // }
}

isNewChatIncrement(){
  this.setState({
    isNewChat : this.state.isNewChat + 1 
  })
}

  updateFeedbackRating(value) {
    this.setState({
      feedbackRating: value.toString()
    });
  }

  onChangeFeedback(value){
    this.setState({
      feedback : value
    })
  }

  submitFeedback(msg){
    log('this.state.feedbackRating',this.state.feedbackRating);
    if (msg && msg.trim() != '') {
      zChat.sendChatComment(msg, function(err) {
        if(err){
          log('Error occured onChatComment>>>', err);
        }
      });
    }

    zChat.sendChatRating(this.state.feedbackRating, function(err) {
      if(err){
        log('Error occured on ChatRating >>>', err);
      }
    });

    log(this.isOffline(),this.props.data.account_status);

    if (this.isOffline()) {
      this.minimizeOnClick();
    } else {
      this.endChat();
    }

  }

  handleOnChange() {
    if (!this.state.typing) {
      zChat.sendTyping(true);
      this.setState({ typing: true });
    }
    this.stopTyping();
  }

  stopTyping() {
    if (!this.state.typing) return;

    zChat.sendTyping(false);
    this.setState({ typing: false });
  }

  handleOnSubmit(event) {
    event && event.preventDefault();

    // Don't allow visitor to send msg if not chatting
    if (this.isOffline()) return;

    const msg = this.refs.input.getRawInput().value;

    // Don't send empty messages
    if (!msg) return;

    // Immediately stop typing
    this.stopTyping.flush();
    zChat.sendChatMsg(msg, (err) => {
      if (err) {
        log('Error occured >>>', err);
      }
      this.props.dispatch({
        type: 'synthetic',
        detail: {
          type: 'visitor_send_msg',
          msg
        }
      });
    });


    this.refs.input.getRawInput().value = '';
  }

  handleFileUpload(event) {
    event.preventDefault();

    // Don't allow visitor to send file if offline
    if (this.isOffline()) return;

    // Only send the first file dropped on input
    const file = event.dataTransfer.files[0];

    // Generate attachment object for local echo
    const attachment = {
      mime_type: file.type,
      name: file.name,
      size: file.size,
      url: window.URL.createObjectURL(file)
    }

    zChat.sendFile(file, (err) => {
      if (err) {
        log('Error occured >>>', err);
        return;
      }
    });

    this.props.dispatch({
      type: 'synthetic',
      detail: {
        type: 'visitor_send_file',
        attachment
      }
    });
  }

  getVisibilityClass() {
    return this.state.visible ? 'visible' : '';
  }

  minimizeOnClick() {
    this.setVisible(false);
    // this.setState({
    //   feedbackVisible: false
    // })
  }

  endChatButtonClick() {
  if(this.state.feedbackVisible){
    this.endChat()
  }
  else{
    this.setState({
      feedbackVisible: true
    })
  }
  }

   endChat() {
    let clearDeptId = {
      clear_dept_id_on_chat_ended: false
  };
  let visitorInfo = {
    display_name : ''
};
    zChat.endChat(clearDeptId, (err)=> {
      if(err){
          log(err);
      }
      // console.log('++++++++++++++++++++++++++ END CHAT ++++++++++++++++++++++++++++++++++++++');
      zChat.setVisitorInfo(visitorInfo,(err)=>{ 
        if(err) {log(err)}
        // console.log('--------VISITOR ID CHANGED ON END CHAT-------------');
        zChat.setVisitorDefaultDepartment(BOT_DEP_ID, function(err) { 
          if(err) {log(err)}
        zChat.sendChatMsg('default_welcome', (err) => {
          if (err) {
            log('Error occured >>>', err);
          }
          if(document.getElementById('msgWrapper').lastChild){
            let prevMsg = document.getElementById('msgWrapper').lastChild;
     
           if(prevMsg.classList.contains('system-msg-container')){
            if(prevMsg.previousSibling){
              let currNode = prevMsg.previousSibling;
    
              while(currNode && currNode.classList.contains('system-msg-container')){
                currNode = currNode.previousSibling;
              }
              if(currNode && currNode.querySelector('.chat-options')){
                currNode.querySelector('.chat-options').style.display = 'none';
              }
            }
           }
            if(prevMsg && prevMsg.querySelector('.chat-options')){
                prevMsg.querySelector('.chat-options').style.display = 'none';
    
            }
          }
        });
      });
       });
  });
    this.setState({
      feedbackVisible: false,
      feedback: false,
      isNewChat : 0
    })
    this.minimizeOnClick();

    let commentAgent = document.getElementById('ebcss-comment');

    commentAgent.value = ''
    let redSmiley = document.getElementById('ebcss-smile-red'),
    orangeSmiley = document.getElementById('ebcss-smile-orange'),
    greenSmiley = document.getElementById('ebcss-smile-green');
    redSmiley.src = IMG_URL + '/ic_smiley_sad_line.png';
    orangeSmiley.src = IMG_URL + '/ic_smiley_neutral_line.png';
    greenSmiley.src = IMG_URL + '/ic_smiley_happy_line.png';

    let errMsgContainer = document.getElementsByClassName(
      'ebcss-feedback-error-msg'
    )[0];
    errMsgContainer.innerHTML = '';
    this.refs.input.getRawInput().value = '';

  }

  chatButtonOnClick() {
      if(!this.props.data.chats.toArray().length) {
        // console.log("+++++++++++++++++ NEW CHAT POP +++++++++++++++")
        if(this.state.isNewChat < 1)
        zChat.setVisitorDefaultDepartment(BOT_DEP_ID, function(err) { 
          if(err) {log(err)}
          zChat.sendChatMsg('default_welcome', (err) => {
            if (err) {
              log('Error occured >>>', err);
            }
          });
      });
      }
      this.setState({
        isNewChat : this.state.isNewChat + 1
      })
      this.setVisible(true);  
  }

  setVisible(visible) {
    this.setState({
      visible
    });
    set('visible', visible);
  }

  mapToEntities(visitor, agents) {
    const entities = {};
    if (visitor) {
      entities[visitor.nick] = {
        ...visitor,
        type: 'visitor'
      };
    }

    if (agents && Object.keys(agents).length) {
      Object.values(agents).forEach((agent) => {
        if (!agent.nick) return;

        entities[agent.nick] = {
          ...agent,
          type: 'agent'
        };
      });
    }

    if (this.props.data.account_status === 'offline' && !this.props.data.is_chatting) {
      entities['agent:offline'] = {
        type: 'agent',
        nick: 'agent:offline'
      }
    }

    return entities;
  }

  setTheme(theme) {
    this.setState({
      theme
    });
    set('theme', theme);
  }

  onThemeChange(theme) {
    if (theme !== 'docked' && theme !== 'normal') {
      theme = 'normal';
    }

    this.setTheme(theme);
  }

  getTheme() {
    return this.state.theme;
  }

  isOffline() {
    return this.props.data.account_status === 'offline' && !this.props.data.is_chatting;
  }
  
  setSateOfChat() {
    var connctionStat = zChat.getConnectionStatus();
    if(!this.state.chatBotState) {
        if (connctionStat == 'connected') !this.state.chatBotState ? this.setState({chatBotState : true}) : null;
    } else {
      return ' visible ';
    }
  }

  render() {
    if (!ACCOUNT_KEY) {
      if (ENV === 'dev') {
        return (
          <div className="warning-container">
            <div className="warning">
              🚨🚨🚨&nbsp;&nbsp;&nbsp;You might have forgotten to configure the widget with your own account key.&nbsp;&nbsp;&nbsp;🚨🚨🚨
              <br/><br/>
              Check the README for more details.
            </div>
          </div>
        );
      }
      else {
        return <div/>;
      }
    }
    const entities = this.mapToEntities(this.props.data.visitor, this.props.data.agents);
    const isOffline = this.isOffline();
    return (
      <div className="index">
        <div className={`widget-container ${this.getTheme()} ${this.getVisibilityClass()}`}>
          <StatusContainer
            accountStatus={this.props.data.account_status}
            minimizeOnClick={this.minimizeOnClick}
            endChatButtonClick={this.endChatButtonClick}
          />
          <FeedbackForm
            addClass={this.state.feedbackVisible? 'visibleFeedback': ''}
            ref="feedbackInput"
            onFeedbackRatingUpdate={this.updateFeedbackRating}
            onFeedbackUpdate={this.submitFeedback}
            feedback={this.state.feedback}
            onChangeFeedback={this.onChangeFeedback}
          />
          <MessageList
            addClass={this.state.feedbackVisible ? 'visible display-none' : 'visible'}
            connection={this.props.data.connection}
            visible={this.state.visible}
            queuePosition={this.props.data.queue_position}
            isChatting={this.props.data.is_chatting}
            isOffline={isOffline}
            messages={this.props.data && this.props.data.chats.toArray()}
            agents={this.props.data.agents}
            entities={entities}
            lastRatingRequestTimestamp={this.props.data.last_rating_request_timestamp}
            hasRating={this.props.data.has_rating}
          />
          {/* <div className={`spinner-container ${this.state.visible && this.props.data.connection !== 'connected' ? 'visible' : ''}`}>
            <div className="spinner"></div>
          </div> */}
          <LoadingScreen  visible = {this.state.visible} connection={this.props.data.connection} dispatch = {this.props.dispatch} isNewChatIncrement={this.isNewChatIncrement}/>
          <Input
            addClass={this.state.feedbackVisible ? 'visible display-none' : 'visible'}
            ref="input"
            onSubmit={this.handleOnSubmit}
            onChange={this.handleOnChange}
            onFocus={this.inputOnFocus}
            onFileUpload={this.handleFileUpload}
          />
        </div>
        <ChatButton addClass={this.setSateOfChat()}  onClick={this.chatButtonOnClick} />
      </div>
    );
  }
}

App.displayName = 'App';

const mapStateToProps = (state) => {
  return {
    data: state
  }
}

const WrappedApp = connect(
  mapStateToProps
)(App);

export default WrappedApp;



// WEBPACK FOOTER //
// ./src/components/Widget.js